import React, {useEffect, useState} from 'react';

import {pushViewTagManager} from '../../services/tagManager/tagManager';
import {Banner} from '../../components/Banner/Banner';
import {Benefits} from '../../components/Benefits/Benefits';
import {Faq} from '../../components/Faq/Faq';
import {GroupOfAcceptedBanks} from '../../components/GroupOfAcceptedBanks';
import {HomeFooter} from '../../components/HomeFooter/HomeFooter';
import {HomeHeader} from '../../components/HomeHeader/HomeHeader';
import {InformationAboutDocuments} from '../../components/InformationAboutDocuments';
import './Home.style.scss';
import {MaintenanceAccreditation} from '../../components/MaintenanceModal/MaintenanceAccreditation';
import {PartnerMachines} from '../../components/PartnerMachines/PartnerMachines';
import {StartAccreditation} from '../../components/StartAccreditation/StartAccreditation';
import {REMOTE_CONFIG_KEYS} from '../../configs/remoteConfigKeys';
import {useRemoteConfig} from '../../hooks/useRemoteConfig';
import {analyticsService} from '../../services/analytics';
import {Modal} from '../../shared/components/Modal';

export const Home = () => {
  const [showModalBanks, setShowModalBanks] = useState(false);
  const [showModalAccreditation, setShowModalAccreditation] = useState(false);
  const {config: remoteConfig} = useRemoteConfig([
    {key: REMOTE_CONFIG_KEYS.MAINTENANCE_MODE, type: 'boolean'}
  ]);

  const isMaintenanceMode =
    remoteConfig[REMOTE_CONFIG_KEYS.MAINTENANCE_MODE] || false;

  const actionModalBanks = () => {
    setShowModalBanks(!showModalBanks);
  };

  const actionModalAccreditation = () => {
    analyticsService.trackButtonClick('credenciamento', 'home');
    setShowModalAccreditation(!showModalAccreditation);
  };

  useEffect(() => {
    pushViewTagManager({
      screenName: 'credenciamento:home',
      appName: 'credenciamento-web',
      sectionApp: 'credenciamento'
    });

    analyticsService.trackPageView('Home');
  }, []);

  useEffect(() => {
    if (isMaintenanceMode) {
      analyticsService.trackMaintenanceView();
    }
  }, [isMaintenanceMode]);

  return (
    <>
      <Modal
        showModal={showModalAccreditation}
        showModalFunction={actionModalAccreditation}
        typeModal="accreditation"
        modalSize={isMaintenanceMode ? 'small' : 'medium'}
      >
        {isMaintenanceMode ? (
          <MaintenanceAccreditation />
        ) : (
          <StartAccreditation />
        )}
      </Modal>

      <Modal showModal={showModalBanks} showModalFunction={actionModalBanks}>
        <GroupOfAcceptedBanks />
      </Modal>

      <section className="page">
        <HomeHeader
          buttonFunctionShowAccreditation={actionModalAccreditation}
        />
        <article className="page__content">
          <Banner />
          <PartnerMachines />
          <InformationAboutDocuments
            buttonFunctionShowBanks={actionModalBanks}
            buttonFunctionShowAccreditation={actionModalAccreditation}
          />
          <Benefits
            buttonFunctionShowAccreditation={actionModalAccreditation}
          />
          <Faq buttonFunctionShowAccreditation={actionModalAccreditation} />
        </article>
        <HomeFooter />
      </section>
    </>
  );
};
